import { client } from './client';
/** Replay a manual-play action list against a level (Module 3). Stateless: the
 *  client holds the action list + seed and re-posts to advance. */
export function runPlay(levelId, req) {
    return client.post(`/levels/${levelId}/play/run`, req);
}
/** The current user's saved play loadout for a level (null if none). */
export function getPlayProfile(levelId) {
    return client.get(`/levels/${levelId}/play-profile`);
}
/** Persist the current user's play loadout for a level. */
export function savePlayProfile(levelId, profile) {
    return client.put(`/levels/${levelId}/play-profile`, profile);
}
